import barba from '@barba/core';
import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
const activeIntroClass = 'filter-intro-is-active';
const newElAnimateClass = 'js-to-animate';

function checkExpertViews(url) {
  const el = document.getElementById('expert-views');
  if (el && !el.classList.contains('expert-views--visible')) {
    if (url.includes('expert-views')) {
      gsap.set(el, {display: 'block'});
    } else {
      gsap.set(el, {display: 'none'});
    }
  }
}

function requestError(trigger, action, url, response) {
  // Barba should automatically redirect if it experiences a timeout but it doesn't seem to.
  // Also the url param seems to always be undefined.
  // We can use the trigger param instead (which seems to be url) and use barba.force to redirect to that url with a full page load.
  // console.log(trigger);
  // console.log(action);
  // console.log(url);
  // console.log(response);
  if (!url) {
    barba.force(trigger);
  }
}

function urlWithoutPage(href) {
  return href
    .replace(/\/p\d+(?=\/|\?|#|$)/, '')
    .replace(/\/page\/\d+(?=\/|\?|#|$)/, '')
    .split('?filters')[0];
}

function ajax(options) {
  const { url, append = false } = options;
  const body = document.body;
  // Add css class - temporarily disable further clicks on filters and cards
  body.classList.add('loading-ajax-cards');

  // XHR fallback without Promises (for testing/logging)
  const xhr = new XMLHttpRequest();
  xhr.open('GET', url);
  xhr.timeout = 5000;
  xhr.setRequestHeader('Accept', 'text/html,application/xhtml+xml,application/xml');
  xhr.setRequestHeader('x-barba', 'yes');
  if (append) {
    xhr.setRequestHeader('x-load-more', '1');
  }

  xhr.onreadystatechange = function() {
    if (xhr.readyState === XMLHttpRequest.DONE) {
      if (xhr.status === 200) {
        console.log('request success');
        // Parse the returned HTML
        const parser = new DOMParser();
        const resHTML = parser.parseFromString(xhr.responseText, "text/html");
        const newContainer = resHTML.getElementById('ajax-cards');
        let ajaxContainer = document.getElementById('ajax-cards');

        if (!newContainer) {
          // Some filtered states return markup without an ajax grid container.
          // Fall back to a full-page navigation rather than throwing.
          body.classList.remove('loading-ajax-cards');
          barba.force(url);
          return;
        }

        // Empty filter results (common on staging) render without #ajax-cards.
        // Mount the returned grid so later filter changes have a container.
        if (!ajaxContainer) {
          const imported = document.importNode(newContainer, true);
          const emptyState = document.querySelector('.events-empty');
          const filters = document.querySelector('.filters');
          const latestContainer = document.querySelector('.latest .container');

          if (emptyState) {
            emptyState.replaceWith(imported);
          } else if (filters) {
            filters.insertAdjacentElement('afterend', imported);
          } else if (latestContainer) {
            latestContainer.appendChild(imported);
          } else {
            body.classList.remove('loading-ajax-cards');
            barba.force(url);
            return;
          }

          ajaxContainer = document.getElementById('ajax-cards');
        }

        if (!ajaxContainer) {
          body.classList.remove('loading-ajax-cards');
          barba.force(url);
          return;
        }

        if (!append) {
          const newFeatured = resHTML.querySelector('.js-featured-grid');
          const currentFeatured = document.querySelector('.js-featured-grid');
          if (currentFeatured && !newFeatured) {
            currentFeatured.remove();
          } else if (newFeatured && currentFeatured) {
            currentFeatured.replaceWith(document.importNode(newFeatured, true));
          } else if (newFeatured && !currentFeatured) {
            ajaxContainer.insertAdjacentElement('beforebegin', document.importNode(newFeatured, true));
          }
        }

        // If we're appending rather than replacing, add class to new cards in so we only animate those
        const newAnimateEls = newContainer.querySelectorAll('.js-ajax-animate');
        newAnimateEls.forEach(card => card.classList.add(newElAnimateClass));
        // Get innerHTML
        const newContent = newContainer.innerHTML;
        // Prevent height 'jump' when swapping content
        const height = ajaxContainer.offsetHeight;
        ajaxContainer.style.height = `${height}px`;

        if (append) {
          const prevLoadMore = document.getElementById('load-more-container');
          if (prevLoadMore) {
            prevLoadMore.remove();
          }
          ajaxContainer.insertAdjacentHTML('beforeend', newContent);
        } else {
          ajaxContainer.innerHTML = newContent;
        }
        barba.history.add(url, 'barba');

        ajaxContainer.style.height = `auto`;

        const els = document.querySelectorAll(`.${newElAnimateClass}`);
        gsap.from(els, {
          opacity: 0,
          y: 10,
          duration: 0.5,
          delay: 0.2,
          stagger: 0.1,
        });
        // Remove newCardClass so you don't animate the same ones again if you load more
        els.forEach(el => el.classList.remove(newElAnimateClass));
        // Show expert views section if present
        checkExpertViews(url);
        body.classList.remove('loading-ajax-cards');
      } else {
        const err = { status: xhr.status, statusText: xhr.statusText };
        console.log(err);
        try { requestError(url, 'click', url, err); } catch (e) {}
        body.classList.remove('loading-ajax-cards');
      }
    }
  };

  xhr.ontimeout = function() {
    const err = new Error('Timeout error [5000]');
    console.log(err);
    try { requestError(url, 'click', url, err); } catch (e) {}
    body.classList.remove('loading-ajax-cards');
  };

  xhr.onerror = function() {
    const err = new Error('Fetch error');
    console.log(err);
    try { requestError(url, 'click', url, err); } catch (e) {}
    body.classList.remove('loading-ajax-cards');
  };

  xhr.send();
}

function updateDropdownFilters(filter, filterContainer) {
  const subDropdowns = Array.from(filterContainer.querySelectorAll('select.js-filter[data-level="2"]'));
  const parentSelect = filterContainer.querySelector('select.js-filter[data-level="1"]');
  const selectedParentOption = parentSelect ? parentSelect.options[parentSelect.selectedIndex] : null;
  const selectedOption = filter.options ? filter.options[filter.selectedIndex] : null;
  const selectedValue = selectedOption && typeof selectedOption.value === 'string' ? selectedOption.value.trim().toLowerCase() : '';
  const selectedLabel = selectedOption && typeof selectedOption.textContent === 'string' ? selectedOption.textContent.trim().toLowerCase() : '';

  // If "Other" is chosen, clear any date input in this filter UI.
  if (selectedValue === 'other' || selectedLabel === 'other') {
    const dateInputs = Array.from(filterContainer.querySelectorAll('input[type="date"]'));
    dateInputs.forEach(input => {
      input.value = '';
    });
  }

  if (filter.dataset.level === "1") {
    const introSelector = selectedParentOption ? selectedParentOption.dataset.intro : '';
    const introContainer = document.getElementById(introSelector);
    const activeIntro = document.querySelector(`.${activeIntroClass}`);

    if (activeIntro) {
      gsap.timeline().to(activeIntro, {
        height: 0,
        duration: 0.2,
        ease: "none",
        onEnd: function() {
          activeIntro.classList.remove(activeIntroClass);
        }
      });
    }

    if (introContainer) {
      gsap.timeline().set(introContainer, {height: 'auto'})
      .from(introContainer, {
        height: 0,
        duration: 0.2,
        ease: 'power2.out',
        immediateRender: false,
        onEnd: function() {
          introContainer.classList.add(activeIntroClass);
        }
      });
    }
  }

  const href = window.location.href;
  let url = urlWithoutPage(href);

  if (filter.dataset.level === "1") {
    subDropdowns.forEach(function(select) {
      if (select !== filter) {
        select.value = '';
      }
    });
  }

  const activeValues = Array.from(filterContainer.querySelectorAll('select.js-filter'))
    .map(select => select.value)
    .filter(Boolean);

  if (activeValues.length) {
    url = `${url}?filters=${activeValues.join(',')}`;
  }

  ajax({url: url});
}

function updateFilters(filter) {
  const filterContainer = filter.closest('.filters');
  const isDropdownMode = filterContainer &&
    filterContainer.dataset.filterMode === 'dropdown' &&
    filter.tagName === 'SELECT';

  if (isDropdownMode) {
    updateDropdownFilters(filter, filterContainer);
    return;
  }

  const subChecked = Array.from(document.querySelectorAll('.js-filter[data-level="2"]:checked'));
  const checkedParentRadio = document.querySelector('.js-filter[data-level="1"]:checked');

  if (filter.dataset.level === "1") {
    const introSelector = checkedParentRadio.dataset.intro;
    const introContainer = document.getElementById(introSelector);
    const activeIntro = document.querySelector(`.${activeIntroClass}`);

    if (activeIntro) {
      gsap.timeline().to(activeIntro, {
        height: 0,
        duration: 0.2,
        ease: "none",
        onEnd: function() {
          activeIntro.classList.remove(activeIntroClass);
        }
      });
    }

    if (introContainer) {
      gsap.timeline().set(introContainer, {height: 'auto'})
      .from(introContainer, {
        height: 0,
        duration: 0.2,
        ease: 'power2.out',
        immediateRender: false,
        onEnd: function() {
          introContainer.classList.add(activeIntroClass);
        }
      });
    }
  }

  const href = window.location.href;
  // Always remove page number when updating filters
  let url = urlWithoutPage(href);
  // Check if need to clear sub filters
  // Parent filters will already be deselected due to being radio inputs
  if (filter.id === 'reset-filters') {
    subChecked.forEach(function(checkBox) {
      checkBox.checked = false;
    })
  } else {
    if (filter.dataset.level === "1") {
      subChecked.forEach(function(checkBox) {
        checkBox.checked = false;
      })
    }

    let updatedChecked = Array.from(document.querySelectorAll('.js-filter:checked'));
    updatedChecked = updatedChecked.filter(checked => checked.id !== 'reset-filters');
    const qString = updatedChecked.reduce((p, c, i) => {
      return p + c.value + `${i < updatedChecked.length - 1 && updatedChecked.length > 1 ? ',' : ''}`;
    }, '?filters=');
    url = url + qString;
  }
  ajax({url: url});
}

export default function() {
  document.addEventListener('click', function(e) {
    // Allow command-click and control-click to open new tab
    // http://henleyedition.com/allow-ctrl-command-click-using-event-preventdefault/
    if (e.metaKey || e.ctrlKey) {
      return;
    }
    const clicked = e.target;
    const loadMore = clicked.closest('#load-more');
    if (loadMore) {
      e.preventDefault();
      const url = decodeURIComponent(loadMore.href);
      ajax({
        url: url,
        append: true
      });
    }
  });

  document.addEventListener('change', function(e) {
    const target = e.target;
    const filter = target.closest('.js-filter');
    if (filter) {
      e.stopPropagation();
      updateFilters(filter);
    }
  });
}
